import { Controller } from 'stimulus';
import dataLayer from '../tracking/dataLayer';

class Hubspot extends Controller {
  connect() {
    const guid = this.data.get('guid');

    window.addEventListener('hs-form-event:on-ready', (event) => {
      if (event.detail.formId === guid) {
        dataLayer.event('hubspot', 'form_loaded', this.data.get('name'));
      }
    });

    window.addEventListener('hs-form-event:on-submission:success', (event) => {
      if (event.detail.formId === guid) {
        dataLayer.event('hubspot', 'form_submitted', this.data.get('name'));
      }
    });

    window.addEventListener('hs-form-event:on-submission:failed', (event) => {
      if (event.detail.formId === guid) {
        dataLayer.event('hubspot', 'form_failed', this.data.get('name'));
      }
    });

    window.addEventListener('hs-form-event:on-interaction:navigate', (event) => {
      if (event.detail.formId === guid) {
        dataLayer.event('hubspot', 'form_navigate', this.data.get('name'));
      }
    });
  }
}

Hubspot.targets = [
  'form',
];

export default Hubspot;
